import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_beverage-innovation/artifacts/thcgu0ac_UI%20Letter%20Head.png";

export default function SplashScreen({ onComplete }) {
  return (
    <motion.div
      data-testid="splash-screen"
      className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #0B1D3A 0%, #1A365D 50%, #0B1D3A 100%)" }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      {/* Dot grid background */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
          backgroundSize: "40px 40px",
        }}
      />

      {/* Radial glow */}
      <motion.div
        className="absolute w-[400px] h-[400px] rounded-full bg-[#C8D616]/15 blur-[100px]"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      />

      {/* Logo + brand name */}
      <div className="relative flex flex-col items-center gap-6">
        <motion.img
          src={LOGO_URL}
          alt="Ultimate Infusions"
          className="h-20 sm:h-24 w-auto rounded-xl"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        />

        <motion.div
          className="flex flex-col items-center gap-1"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.35, ease: "easeOut" }}
        >
          <div
            className="flex gap-0.5 w-[140px] sm:w-[160px] text-white"
            style={{ fontFamily: "'Controller W01 Three', sans-serif" }}
          >
            <span className="flex justify-between w-full text-xl sm:text-2xl leading-none">
              {"ULTIMATE".split("").map((c, i) => (
                <span key={i}>{c}</span>
              ))}
            </span>
          </div>
          <div
            className="flex gap-0.5 w-[140px] sm:w-[160px] text-[#C8D616]"
            style={{ fontFamily: "'Controller W01 Three', sans-serif" }}
          >
            <span className="flex justify-between w-full text-xl sm:text-2xl leading-none">
              {"INFUSIONS".split("").map((c, i) => (
                <span key={i}>{c}</span>
              ))}
            </span>
          </div>
        </motion.div>

        {/* Animated progress bar */}
        <motion.div
          className="mt-4 h-[2px] rounded-full bg-[#C8D616]/30 overflow-hidden w-32"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <motion.div
            className="h-full bg-[#C8D616] rounded-full"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 1.2, delay: 0.6, ease: "easeInOut" }}
            onAnimationComplete={onComplete}
          />
        </motion.div>
      </div>
    </motion.div>
  );
}
